import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './style/InnerTransition.css';

// Duration also exists in css
export const DURATION = 400;
export const SCALE = 'Scale';
export const SLIDE_UP = 'SlideUp';
export const SLIDE_LEFT = 'SlideLeft';
export const SLIDE_RIGHT = 'SlideRight';

export default class InnerTransition extends React.Component {
  state = {
    currentTransitionKey: this.props.transitionKey,
    prevTransitionKey: null,
    prevValidTransitionKey: null,
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.transitionKey !== prevState.currentTransitionKey) {
      const updatedState = {
        currentTransitionKey: nextProps.transitionKey,
        prevTransitionKey: prevState.currentTransitionKey,
      };
      if (prevState.currentTransitionKey) {
        updatedState.prevValidTransitionKey = prevState.currentTransitionKey;
      }
      return updatedState;
    }
    return null;
  };

  shouldBlockTransition() {
    const firstLoad = this.state.prevValidTransitionKey === null;
    const reloadedRoute =
      this.state.prevValidTransitionKey === this.state.currentTransitionKey;
    return firstLoad || reloadedRoute || this.props.transitionKey === null;
  }

  getTransition() {
    const suffix = this.props.transition ? this.props.transition : SCALE;
    return `InnerTransition__${suffix}`;
  }

  render() {
    const classes = ['InnerTransition'];
    if (this.props.flex) {
      classes.push('InnerTransition--Flex');
    } else if (this.props.hundredPercent) {
      classes.push('InnerTransition--HundredPercent');
    }

    return (
      <TransitionGroup className={classes.join(' ')}>
        <CSSTransition
          classNames={this.getTransition()}
          timeout={DURATION}
          key={this.props.transitionKey}
          exit={false}
          enter={!this.shouldBlockTransition()}
        >
          <div className="InnerTransition__Content">{this.props.children}</div>
        </CSSTransition>
      </TransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/InnerTransition.js